import { SVGProps } from 'react';

const LiveChatIcon = ({
  width = 18,
  height = 18,
  className,
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-palette="LiveChatIcon">
    <path
      d="M12.75 8.60378C12.75 8.34428 12.75 8.21453 12.789 8.09903C12.9023 7.76303 13.2015 7.63328 13.5015 7.49678C13.8375 7.34303 14.0055 7.26653 14.1728 7.25303C14.3618 7.23803 14.5515 7.27853 14.7135 7.36928C14.928 7.48928 15.078 7.71878 15.231 7.90478C15.9383 8.76428 16.2923 9.19403 16.4213 9.66728C16.5263 10.0498 16.5263 10.4503 16.4213 10.832C16.233 11.5235 15.6368 12.1025 15.195 12.6395C14.9693 12.9133 14.856 13.0505 14.7135 13.1308C14.5488 13.2222 14.3606 13.2626 14.1728 13.247C14.0055 13.2335 13.8375 13.157 13.5008 13.0033C13.2008 12.8668 12.9023 12.737 12.789 12.401C12.75 12.2855 12.75 12.1558 12.75 11.8963V8.60378ZM5.25 8.60378C5.25 8.27678 5.241 7.98353 4.977 7.75403C4.881 7.67078 4.7535 7.61303 4.49925 7.49678C4.1625 7.34378 3.9945 7.26653 3.82725 7.25303C3.327 7.21253 3.05775 7.55453 2.76975 7.90553C2.06174 8.76428 1.70774 9.19403 1.57799 9.66803C1.4736 10.0493 1.4736 10.4516 1.57799 10.8328C1.76699 11.5235 2.36399 12.1033 2.805 12.6395C3.08325 12.977 3.3495 13.2853 3.82725 13.247C3.9945 13.2335 4.1625 13.157 4.49925 13.0033C4.75425 12.8878 4.881 12.8293 4.977 12.746C5.241 12.5165 5.25 12.2233 5.25 11.897V8.60378Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 7.25001C3.75 4.7645 6.10051 2.75 9.00002 2.75C11.8995 2.75 14.25 4.7645 14.25 7.25001M14.25 13.25V13.85C14.25 15.1753 12.9075 16.25 11.25 16.25H9.75002"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LiveChatIcon;
